module.exports = __webpack_public_path__ + "static/media/btc.svg.7a4072aa.png";